/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const totalOrganizationStatsSchema = z.object({
	organization_id: z.uuid(),
	organization_name: z.string(),
	order_count: z.int(),
	total_sum: z.number(),
	avg_check: z.number(),
	iiko_total_order_count: z.int().optional(),
	iiko_total_sum: z.number().optional(),
	iiko_avg_check: z.number().optional(),
	non_inno_order_count: z.int().optional(),
	non_inno_total_sum: z.number().optional(),
	non_inno_avg_check: z.number().optional(),
	cooking_time_avg_sec: z.int().optional(),
	order_close_time_avg_sec: z.int().optional(),
});
